import Vue from 'vue'
import VueRouter from 'vue-router'

import TodoContents from '../components/TodoContents'
import TodoLogin from '../components/TodoLogin'
import TodoNew from '../components/TodoNew'
import TodoView from '../components/TodoView'
import TodoEdit from '../components/TodoEdit'
import TodoBin from '../components/TodoBin'

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', component: TodoLogin },
        { path: '/todo', name: 'Todolist', component: TodoContents },
        { path: '*', component: TodoLogin },
        { path: '/create', component: TodoNew},
        { path: '/view/:todo_id', name: 'Todoview', component: TodoView},
        { path: '/edit/:todo_id', name: 'Todoedit', component: TodoEdit},
        { path: '/bin', name: 'Todobin', component: TodoBin},
    ]
})

export default router



// WEBPACK FOOTER //
// ./src/route/index.js